import type { ModalAction } from "domains/modal/actionTypes";
import { ModalTypes } from "domains/modal/actionTypes";
import type { ModalState } from "domains/modal/types";

const initialState: ModalState = { activeModals: [] };

export const modalReducer = (state = initialState, action: ModalAction): ModalState => {
  switch (action.type) {
    case ModalTypes.ACTIVATE:
      return {
        ...state,
        activeModals: [action.meta],
      };
    case ModalTypes.DEACTIVATE:
      return {
        ...state,
        activeModals: [],
      };
    case ModalTypes.PUSH_SCREEN:
      return {
        ...state,
        activeModals: [...state.activeModals, action.meta],
      };
    case ModalTypes.POP_SCREEN:
      return {
        ...state,
        activeModals: state.activeModals.slice(0, state.activeModals.length - 1),
      };
    default:
      return state;
  }
};
